import React, { useState } from "react";
import SessionModel from "../api/models/SessionModel";

export function useSessionsNumber() {
  // TODO: to be fetched from the API
  const START_SESSION_NUMBER = 1;
  const [sessionsCounter, setSessionsCounter] =
    useState<number>(START_SESSION_NUMBER);
  return sessionsCounter;
}

